import firebase from 'firebase'

var firebaseConfig = {
    apiKey: "AIzaSyCzgCMHUnI0Ls_fb6KBeq11XGy_B69RfS0",
    authDomain: "bounce-d368c.firebaseapp.com",
    databaseURL: "https://bounce-d368c.firebaseio.com",
    projectId: "bounce-d368c",
    storageBucket: "bounce-d368c.appspot.com",
    messagingSenderId: "642124662579",
    appId: "1:642124662579:web:83831e1d6b1a35d5f2a046"
  };

var fire = firebase.initializeApp(firebaseConfig);

export default fire;